<template>
  <Base
    :detail="detail"
    v-if="defaultPrize && defaultPrize.length > 0"
    :show-loading="showLoading"
  >
    <div class="luckdraw-warp" :style="'width:' + 680 * baseSize + 'px;'">
      <div
        class="luckdraw-card"
        :style="'background: url(' + scratchCardBack + ') no-repeat center;'"
      >
        <vue-scratch-card
          v-if="showCard"
          :start-callback="start"
          :clear-callback="endCallback"
          element-id="luckdraw-card-box"
          :cover-img="scratchCardMask"
        >
          <div slot="result" class="luckdraw-card-result">
            {{ result.title || "" }}
          </div>
        </vue-scratch-card>
      </div>
    </div>
    <div
      class="active-num"
      :style="
        'margin-top:-' +
          10 * baseSize +
          'px;margin-bottom:' +
          56 * baseSize +
          'px;width:' +
          692 * baseSize +
          'px'
      "
    >
      <img :src="luckyDrawNums" />
      <div
        class="active-num-text"
        :style="
          'bottom:' + 60 * baseSize + 'px; font-size:' + 24 * baseSize + 'px'
        "
      >
        <!-- 已有<span>{{ detail.join_num }}</span
        >人参与<br />
        您今天还有<span class="underline yellow">{{ chance }}</span
        >次抽奖机会 -->
        You've got <span class="underline yellow">{{ chance }}</span
        > times<br>left to draw for today.
      </div>
    </div>
    <PrizeDetail :detail="detail" :myAwards="myAwards" />
  </Base>
</template>

<script>
import { LuckDrawMixin } from "@/mixins/Luckdraw";
import scratchCardBack from "@/assets/img/award/scratchcard3.png";
import luckyDrawNums from "@/assets/img/award/scratchcard.png";
import scratchCardMask from "@/assets/img/award/scratchCardMask";
export default {
  mixins: [LuckDrawMixin],
  data() {
    return {
      scratchCardBack,
      luckyDrawNums,
      scratchCardMask,
      defaultPrize: [],
      running: false,
      showCard: true
    };
  },

  methods: {
    init() {
      this.showCard = false;
      this.running = false;
      setTimeout(() => {
        this.showCard = true;
      }, 100);
    },
    start() {
      if(!this.checkLogin()){
        this.init();
        return ;}
      if (this.running) return;
      const endTime = this.detail.end_time
        ? new Date(this.detail.end_time.replace(/-/g, "/")).getTime()
        : "";
      const nowTime = new Date().getTime();
      if (!endTime || endTime < nowTime) {
        this.showMessage("Game over!");
        return;
      }
      if (this.chance < 1) {
        this.showMessage("No chance today, come back tomorrow.!");
        return;
      }
      this.running = true;
      this.showLoading = true;
      this.getResult();
    },
    handleData(data) {
      let temp = { ...data };
      if (!temp.background_img)
        temp.background_img = require("@/assets/img/award/beij.jpg"); // baseOssUrl +'/market-front/award/beij.jpg';
      if (!temp.brief_img)
        temp.brief_img = require("@/assets/img/award/title.png"); // baseOssUrl + '/market-front/award/title.png';
      this.detail = { ...temp };
      this.myAwards = [...this.detail.my_awards];
      this.chance = this.detail.remaining_num || 0;
      this.defaultPrize = [...data.prizes];
    },
    handleResult(data) {
      this.showLoading = false;
      this.chance -= 1;
      const { id, title, level, image } = data.award;
      if(id) this.myAwards.unshift({ id, title, level, image });
      this.result = { ...data.award };
    },
    endCallback() {
      const { id, title, level } = this.result;
      // this.myAwards.unshift({ id, title, level, image });
      setTimeout(() => {
        if (id === 0) {
          this.showResult({ type: 1 });
        } else {
          this.showResult({ type: 3, title, level });
        }
      }, 500);
    }
  }
};
</script>

<style scoped lang="scss">
img {
  display: block;
  max-width: 100%;
}

.underline {
  text-decoration: underline;
}

.luckdraw-warp {
  position: relative;
  z-index: 2;
  perspective: 500;
  -webkit-perspective: 500;
  perspective-origin: center bottom;
  -webkit-perspective-origin: center bottom;
  margin: 0 auto;
  .luckdraw-card {
    width: 34rem;
    height: 16.8rem;
    background-size: 100% !important;
    border-radius: 1.1rem;
    padding: 1.5rem 1.5rem 1.5rem 1.5rem;
    #luckdraw-card-box {
      position: relative;
      height: 13.8rem;
      width: 31rem;
      border-radius: 1.1rem;
      overflow: hidden;
      .luckdraw-card-result {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding: 1rem;
        font-size: 2.8rem;
        font-weight: bold;
        color: #f7760e;
        height: 100%;
      }
    }
  }
}

.active-num {
  position: relative;
  z-index: 3;
  margin-left: auto;
  margin-right: auto;
  img {
    padding-left: 1%;
  }
}
.active-num-text {
  font-size: 12px;
  text-align: center;
  color: #fff;
  line-height: 1.4;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  span {
    display: inline-block;
    margin: 0 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ScratchCard.vue